<mat-form-field
  [floatLabel]="floatLabel"
  [ngStyle]="{'font-size': (fontSize) ? fontSize : ''}"
>
  <input
    [id]="name+'_input'"
    [name]="name"
    matInput
    #value="ngModel"
    [disabled]="!editable"
    [(ngModel)]="valueDisplay"
    (ngModelChange)="valueChanged($event)"
    placeholder="{{placeholder}}"
    appValidateInput
    [preventNanValues]="enableNanValidation"
    [preventNegativeValues]="enableNegativeValidation"
    (errorMessageUpdate)="updateErrorMessage($event)"
    [setErrorMessage]="errorMessage"
    (validationUpdated)="touchValueControl()"
    [validationID]="validationID !== '' ? validationID : name">
  <mat-hint class="warning-hint"
            [innerHTML]="warningMessage"
  ></mat-hint>
  <mat-error [innerHTML]="errorMessage"></mat-error>
</mat-form-field>
